/*
this is a UI-only model
it represents an interaction node, corresponding interaction, and an array of settings for that interaction_x_interval
*/

class InteractionIntervalSetting {
  interaction_node_interval_id: number;
  interaction_id: number;
  interaction_node_id: number;
  interval_id: number;
  selected: boolean;
  condition_id: number | null;
  communication_set_id: number | null;
  communication_set_name: string | null;
  editMode: boolean;
  interval_set_id?:number

  constructor(
    interaction_node_interval_id: number,
    interaction_id: number,
    interaction_node_id: number,
    interval_id: number,
    selected: boolean,
    condition_id: number | null,
    communication_set_id: number | null,
    communication_set_name: string | null,
    editMode: boolean,
    interval_set_id?: number
  ) {
    this.interaction_node_interval_id = interaction_node_interval_id;
    this.interaction_id = interaction_id;
    this.interaction_node_id = interaction_node_id;
    this.interval_id = interval_id;
    this.selected = selected;
    this.condition_id = condition_id;
    this.communication_set_id = communication_set_id;
    this.communication_set_name = communication_set_name;
    this.editMode = editMode;
    this.interval_set_id = interval_set_id

  }
}

export default InteractionIntervalSetting;
